import { render, staticRenderFns } from "./regrecordedetail.vue?vue&type=template&id=a3c72926"
import script from "./regrecordedetail.vue?vue&type=script&lang=js"
export * from "./regrecordedetail.vue?vue&type=script&lang=js"
import style0 from "./regrecordedetail.vue?vue&type=style&index=0&id=a3c72926&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports